<template>
  <div>
    <v-card min-width="320px">
      <v-toolbar flat color="primary">
      <v-title>
        {{ selectedCustomer.PARTYMST_DESC }}
      </v-title>
      <v-progress-circular
          v-if="loading"
          indeterminate
          color="white"
        ></v-progress-circular>
        <v-spacer></v-spacer>
        <v-btn icon  @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>      
      <v-list flat>              
        <v-list-item-group color="primary">
          <v-list-item
            v-for="contact in this.allContacts"
            :key="
              contact.ACCONDET_DOCTYPE +
                contact.ACCONDET_DOCNO +
                contact.ACCONDET_DOCSRNO
            "
            :label="contact.ACCONDET_NAME"
            ><v-col cols="12">
              <v-list-item-content @click="selectContact(contact)">
                <v-badge
                  v-show="contact.ACCONDET_REMARKS == 'VERIFIED'"
                  class="mx-2"
                  color="green"
                  left
                  overlap
                  icon="mdi-security"
                />
                <v-list-item-title
                  class="mx-6"
                  v-text="contact.ACCONDET_NAME"
                />
                <v-list-item-subtitle
                  class="mx-6 d-flex align-center"
                  v-text="contact.ACCONDET_DESIGNATION"
                />
                <v-list-item-subtitle
                  v-show="contact.CNT_DESC"
                  v-text="` (${contact.CNT_DESC} contact)`"
                  class="mx-6 d-flex align-center"
                />
              </v-list-item-content>
              <v-row dense class="mt-2 d-flex justify-space-between">
                <v-col cols="4" class="d-flex justify-center">
                  <v-btn
                    fab
                    dark
                    small
                    color="primary"
                    @click="callContact(contact.ACCONDET_MOBILE)"
                  >
                    <v-icon dark>
                      mdi-phone
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="4" class="d-flex justify-center">
                  <v-btn
                    class=""
                    fab
                    dark
                    small
                    color="primary"
                    @click="
                      navContact(
                        contact.ACCONDET_GPSLAT,
                        contact.ACCONDET_GPSLON
                      )
                    "
                  >
                    <v-icon dark>
                      mdi-navigation
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="4" class="d-flex justify-center">
                  <v-btn
                    class=""
                    fab
                    dark
                    small
                    color="primary"
                    @click="addFlwUp(contact)"
                  >
                    <v-icon dark>
                      mdi-message-draw
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider class="mt-2"></v-divider>
            </v-col>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-card-actions>
      <v-alert
        outlined   
        prominent  
        shaped
        text
        type="warning"
        v-if = "!(newcontact)"
      >
      Contact Credit Control Team for new contact creation, Since number of contacts exceding limit of maxium 3 contacts per customer.
    </v-alert>
        <!-- <v-text   type="warning" :disabled= true>Contact Credit Control Team for new contact creation, Since  number of contacts exceding limit of maxium 3 contact per customer</v-text>   -->
        <v-spacer></v-spacer>
        <!-- <v-spacer>Contact Credit Control Team for new contact creation, {{`Since ${this.numberofcontacts-3 } number of contacts exceding limit of maxium 3 contact per customer`}}</v-spacer> -->
        <!-- <v-btn color="primary" fab @click="addNewContact" > -->
        <v-btn color="primary" fab @click="addNewContact" v-if="newcontact">
          <v-icon>
            mdi-account-plus
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Contselect",
  props: [],
  data() {
    return {};
  },

  computed: {
    selectedCustomer() {
      return this.$store.getters.thiscustomer;
    },
    allContacts() {
      return this.$store.getters.allcontacts;
    },
    loading() {
      return this.$store.getters.loading;
    },
    numberofcontacts(){
      return this.allContacts.length;
    },
    fbuserdata(){
      return this.$store.getters.fbuserdata;
    },
    samplecustomer(){     
      if (this.selectedCustomer.PARTYMST_DESC.startsWith('SAMPLE'))
      return true
      else
      return false
    },
    isAdmin(){
      if(this.fbuserdata.usertype == 1 || this.fbuserdata.newcontact == true) return true
      else return false
    },
    isAllowed(){
      if( this.fbuserdata.newcontactcustomers !=null && this.fbuserdata.newcontactcustomers!=undefined){
        return this.fbuserdata.newcontactcustomers.includes(this.selectedCustomer.CustomerCode)}
      return false

    },
    newcontact(){
      if(this.samplecustomer || this.isAdmin || this.isAllowed)
        return true
      else if(this.numberofcontacts < 3)
        return true
      else
        return false
    }
  },
  methods: {
    selectContact(contact) {
      this.$store.dispatch("selectThisContact", contact);
      this.$store.dispatch("getMyLocation");
      this.$store.dispatch("getTgtLocation", {
        latitude: contact.ACCONDET_GPSLAT,
        longitude: contact.ACCONDET_GPSLON,        
      });
      // console.log(contact.ACCONDET_GPSLAT,contact.ACCONDET_GPSLON)
      this.$store.dispatch("getDistBetween");
      this.$emit("selectContact");
      console.log(contact);
    },

    callContact(mob) {
      window.open(`tel:${mob}`);
    },

    navContact(lat, lng) {
      window.open(`https://maps.google.com/?q=${lat},${lng}`);
      console.log(lat, lng);
    },
    closeDialog() {
      this.$emit('close');
    },

    addFlwUp(contact) {
      this.selectContact(contact);
      this.$store.dispatch("getCustomerOutsDocs", {
        doctype: contact.ACCONDET_DOCTYPE,
        docno: contact.ACCONDET_DOCNO,
      });
      this.$store.dispatch("clearProductsList");
      this.$router.push({ path: "/journalentry" });
    },

    addNewContact() {
      this.$emit("contOutNewIn");
    },
  },
};
</script>

<style scoped></style>
